// extracted by mini-css-extract-plugin
export var productImage = "_np-0";